import TemperatureUnitsSelector from './TemperatureUnitsSelector';

export default TemperatureUnitsSelector;
